

const SELF = '#shakuf-root';


const NO_SPACING = `svg, svg *, i, [class*="icon"], [class*="Icon"], [class*="fa-"], .material-icons`;


function motionRule(exclude: string | null): string {
  // `:is()` normalises a comma list inside `:not()` and forgives an invalid
  // arm; the second `:not()` covers descendants, so an excluded element keeps
  // the machinery its own reduced-motion CSS was written to rearrange.
  const skip = exclude ? `:not(:is(${exclude})):not(:is(${exclude}) *)` : '';
  const base = `html[data-shakuf-motion="off"] body *:not(${SELF})${skip}`;

  return  `

${base},
${base}::before,
${base}::after {
  animation-duration: .01ms !important;
  animation-delay: 0s !important;
  animation-iteration-count: 1 !important;
  transition-duration: .01ms !important;
  transition-delay: 0s !important;
  scroll-behavior: auto !important;
}

html[data-shakuf-motion="off"],
html[data-shakuf-motion="off"] body {
  scroll-behavior: auto !important;
  animation-duration: .01ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: .01ms !important;
}
`;
}


export const buildHostStyles = (motionExclude: string | null = null): string =>  `

html[data-shakuf-line="1"] body *:not(${NO_SPACING}):not(${SELF}) { line-height: 1.6 !important; }
html[data-shakuf-line="2"] body *:not(${NO_SPACING}):not(${SELF}) { line-height: 2 !important; }

html[data-shakuf-letter="1"] body *:not(${NO_SPACING}):not(${SELF}) { letter-spacing: 0.12em !important; }
html[data-shakuf-letter="2"] body *:not(${NO_SPACING}):not(${SELF}) { letter-spacing: 0.2em !important; }

html[data-shakuf-word="1"] body *:not(${NO_SPACING}):not(${SELF}) { word-spacing: 0.16em !important; }
html[data-shakuf-word="2"] body *:not(${NO_SPACING}):not(${SELF}) { word-spacing: 0.3em !important; }


html[data-shakuf-font="readable"] body *:not(${NO_SPACING}):not(${SELF}) {
  font-family: Arial, "Segoe UI", Tahoma, sans-serif !important;
}


html[data-shakuf-align="start"] body *:not(${SELF}) {
  text-align: start !important;
  text-justify: none !important;
}



html[data-shakuf-contrast="invert"]    { --shakuf-invert: invert(1); }
html[data-shakuf-contrast="mono"]      { --shakuf-invert: grayscale(1); }
html[data-shakuf-saturation="low"]     { --shakuf-sat: saturate(0.5); }
html[data-shakuf-saturation="high"]    { --shakuf-sat: saturate(1.6); }


html[data-shakuf-contrast="invert"],
html[data-shakuf-contrast="mono"],
html[data-shakuf-saturation="low"],
html[data-shakuf-saturation="high"] {
  filter: var(--shakuf-invert, invert(0)) var(--shakuf-sat, saturate(1)) !important;
}


html[data-shakuf-contrast="invert"] img,
html[data-shakuf-contrast="invert"] video {
  filter: invert(1) !important;
}


html[data-shakuf-contrast="high"] body,
html[data-shakuf-contrast="high"] body *:not(${SELF}):not(:where(svg, svg *)) {
  background-color: #000 !important;
  background-image: none !important;
  color: #fff !important;
  border-color: #fff !important;
  text-shadow: none !important;
  box-shadow: none !important;
}

html[data-shakuf-contrast="high"] body *:not(${SELF}):focus-visible {
  outline: 3px solid #ffe600 !important;
  outline-offset: 2px !important;
}
html[data-shakuf-contrast="high"] body a:not(${SELF}) { color: #ffe600 !important; }
html[data-shakuf-contrast="high"] body a:not(${SELF}):visited { color: #ffb3ff !important; }
html[data-shakuf-contrast="high"] body button:not(${SELF}),
html[data-shakuf-contrast="high"] body input:not(${SELF}),
html[data-shakuf-contrast="high"] body select:not(${SELF}),
html[data-shakuf-contrast="high"] body textarea:not(${SELF}) {
  background-color: #000 !important;
  color: #fff !important;
  border: 2px solid #fff !important;
}


html[data-shakuf-links="1"] body a:not(${SELF}) {
  text-decoration: underline !important;
  text-underline-offset: 2px !important;
  outline: 2px solid currentColor !important;
  outline-offset: 2px !important;
}
html[data-shakuf-links="1"] body a:not(${SELF}):focus-visible {
  outline-width: 4px !important;
  outline-offset: 4px !important;
}


html[data-shakuf-images="hidden"] body img:not(${SELF}),
html[data-shakuf-images="hidden"] body picture:not(${SELF}) {
  opacity: 0 !important;
}
html[data-shakuf-images="hidden"] body *:not(${SELF}) {
  background-image: none !important;
}

${motionRule(motionExclude)}


html[data-shakuf-focus="strong"] body *:not(${SELF}):focus,
html[data-shakuf-focus="strong"] body *:not(${SELF}):focus-visible {
  outline: 4px solid #ff8c00 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.65) !important;
}


html[data-shakuf-cursor="big"] body *:not(${SELF}) {
  cursor: url('data:image/svg+xml;utf8,\
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 32 32">\
<path d="M6 2l0 22 5.5-5.5 3.5 8 4-1.8-3.4-7.8 7.4 0z" fill="%23000" stroke="%23fff" stroke-width="1.5"/>\
</svg>') 6 2, auto !important;
}
html[data-shakuf-cursor="big"] body a:not(${SELF}),
html[data-shakuf-cursor="big"] body button:not(${SELF}),
html[data-shakuf-cursor="big"] body [role="button"]:not(${SELF}) {
  cursor: url('data:image/svg+xml;utf8,\
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 32 32">\
<path d="M12 2c-1.1 0-2 .9-2 2v12l-3-3c-1-1-2.5-1-3.5 0s-1 2.5 0 3.5l8 9h12l2-12c.2-1.2-.6-2.3-1.8-2.5s-2.3.6-2.5 1.8V4c0-1.1-.9-2-2-2s-2 .9-2 2v-.5c0-1.1-.9-2-2-2s-2 .9-2 2V4c0-1.1-.9-2-2-2z" fill="%23000" stroke="%23fff" stroke-width="1.5"/>\
</svg>') 12 2, pointer !important;
}
`;

const STYLE_ID = 'shakuf-host-styles';


export function ensureHostStyles(motionExclude: string | null = null): void {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = buildHostStyles(motionExclude);
  document.head.appendChild(style);
}


export function setHostAttr(name: string, value: string | null): void {
  const root = document.documentElement;
  if (value === null) root.removeAttribute(`data-shakuf-${name}`);
  else root.setAttribute(`data-shakuf-${name}`, value);
}


export function clearHostAttrs(): void {
  const root = document.documentElement;
  for (const attr of Array.from(root.attributes)) {
    if (attr.name.startsWith('data-shakuf-')) root.removeAttribute(attr.name);
  }
}
